import {REVIEW_SCORE_AMADEUS_THRESHOLD_EXCELLENT} from '@/consts';

export const isHighRatedWithManyReviews = (
  ratingScore?: number,
  reviewCount?: number
): boolean => {
  return (
    typeof ratingScore === 'number' &&
    ratingScore >= REVIEW_SCORE_AMADEUS_THRESHOLD_EXCELLENT &&
    typeof reviewCount === 'number' &&
    reviewCount >= 100
  );
};
